import React, {PropTypes as T} from 'react';
import ReactDOM from 'react-dom';
import Tooltip from './tooltip';

export default class TooltipInitializer extends React.Component {
  static propTypes = {
    children: T.node,
    selector: T.string,
    dismissOnScroll: T.bool,
    focusSelector: T.string,
    closeSelector: T.string,
    labeledBy: T.string
  };

  static defaultProps = {
    dismissOnScroll: true
  };

  componentDidMount () {
    this.node = document.createElement('div');
    document.body.appendChild(this.node);

    ReactDOM.render(
      <Tooltip
        selector={this.props.selector}
        dismissOnScroll={this.props.dismissOnScroll}
        focusSelector={this.props.focusSelector}
        closeSelector={this.props.closeSelector}
        labeledBy={this.props.labeledBy}
      >
        {this.props.children}
      </Tooltip>,
      this.node
    );
  }

  componentWillUnmount () {
    ReactDOM.unmountComponentAtNode(this.node);
    this.node.parentNode && this.node.parentNode.removeChild(this.node);
  }

  render () {
    return <script />;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/tooltip/index.js